module.exports = __webpack_public_path__ + "static/media/dsc.0fd71daa.jpg";